module.exports = __webpack_public_path__ + "img/7.c426d3cc.png";